import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { App } from '@df/core/app';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { Product } from '../product.decorator';
type IProductViewTreeBlockData = Catalog.IBlockData<IProductViewTreeBlockDataContent>;
interface IProductViewTreeBlockDataContent {
    attribute: string;
    text: string;
    cta_text?: string;
    cta_url?: string;
    image: string;
}
@Component({
    selector: 'product-view-tree',
    templateUrl: './product-view-tree.html',
    standalone: true,
    imports: [CommonModule, RouterLink, ImageModule, ICmsClientModule]
})
@ICmsComponent<ProductViewTreeComponent>({
    id: 'cms-product-view-tree',
    block: {
        url: 'cms-product-view-tree'
    },
    onDemandOnly: true,
    name: 'Product view Plant a tree',
    description: 'Product view Plant a tree block',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'attribute',
            type: NICmsContentField.EFieldType.choice,
            title: 'Attribute',
            options: () => {
                if (typeof window !== 'undefined') {
                    return (
                        (<App>window['app'])?.resources?.attribute?.getAllExisting().map(i => {
                            return {
                                key: i.id,
                                value: i.id,
                                title: i.data?.label
                            };
                        }) || []
                    );
                }
                return [];
            },
            required: true
        },
        { key: 'text', type: NICmsContentField.EFieldType.text, title: 'Text', required: true },
        { key: 'cta_text', type: NICmsContentField.EFieldType.text, title: 'CTA text' },
        { key: 'cta_url', type: NICmsContentField.EFieldType.text, title: 'CTA Url' },
        { key: 'image', type: NICmsContentField.EFieldType.image, title: 'Image', required: true }
    ]
})
export class ProductViewTreeComponent
    extends UiComponent
    implements NICmsContentComponent.IComponent, OnInit, OnChanges, OnDestroy
{
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IProductViewTreeBlockDataContent;
    @Input()
    product?: Product;
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes['product'] && this.initiated) {
            this.detectChanges();
        }
    }
    get display(): boolean {
        const attributeCode = this.content?.attribute;
        if (attributeCode && this.product?.data) {
            return !!this.product.data[attributeCode];
        }
        return false;
    }
}
